<template>
  <div>
    <a-modal 
      :visible.sync="visible"
      :width="'90%'"
      @cancel="visible=false"
      :maskClosable="false"
      :destroyOnClose="true"
      :title="unit.unitName" onOk="handleOk" :footer="null">
      
      <!-- <template slot="footer">
        <a-button key="back" @click="handleCancel">关闭</a-button>
      </template> -->
            
      <a-row :gutter="24">
        <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
            <div v-if="videoUrl" class="video-area">
              <video oncontextmenu="return false;" controlsList='nodownload noremote footbar' :src="videoUrl" controls="true"></video>
            </div>
            <div v-if="mediaContent" v-html="mediaContent" class="video-area">
            </div>
        </a-col>
        <a-divider v-if="_isMobile()"/>
        <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <div class="unit-list">
              <a-timeline>
                <a-timeline-item color="blue" v-for="media in mediaList" :key="media.id">
                  <a-icon v-if="media.mediaType==5" slot="dot" type="edit" style="font-size: 16px;" />
                  <a-icon v-if="media.mediaType==1" slot="dot" type="play-circle" style="font-size: 16px;" />
                  <a-icon v-if="media.mediaType==3" slot="dot" type="snippets" style="font-size: 16px;" />
                  <a-button block @click="changeMedia(media)">
                    {{media.mediaName}}<a-icon type="right"/>
                  </a-button>
                </a-timeline-item>
            </a-timeline>
            <a-card v-if="unit.unitIntro" size="small" title="课程说明">
              <div v-html="unit.unitIntro ? unit.unitIntro.replace(/\n/g,'<br>') : ''"></div>
            </a-card>
            </div>
        </a-col>
      </a-row>

      <div v-if="false">
        <a-divider>本节课作业</a-divider>
        <a-row :gutter="24">
          <a-col :span="16">
            <a-card size="small" title="课程说明">
              <div v-html="unit.unitIntro ? unit.unitIntro.replace(/\n/g,'<br>') : ''"></div>
            </a-card>
          </a-col>
          <a-col :span="8">
            <a-collapse defaultActiveKey="0" :bordered="false">
              <template v-slot:expandIcon="props">
                <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
              </template>
              <a-collapse-panel :header="'课后作业'"  :style="customStyle">
                <a target="_blank" :href="'/scratch/index.html?unitId='+unit.id"><a-icon type="edit" />{{unit.unitName}} 去做作业</a>
              </a-collapse-panel>
              <a-collapse-panel :header="'课程资料'"  :style="customStyle">
                <a target="_blank" :href="getQiniuFile(unit.coursePpt)"><a-icon type="edit" />{{unit.unitName}} 查看PPT</a>
              </a-collapse-panel>
            </a-collapse>
          </a-col>
        </a-row>
      </div>
    </a-modal>
  </div>
</template>
<script>
// import '@/components/jeecg/JModal'
import { getAction } from '@/api/manage'
import {mixinDevice} from '@/utils/mixin.js'

export default {
  name: 'UnitViewModal',
  mixins: [mixinDevice],
  data() {
    return {
      customStyle:
          'background: #f7f7f7;border-radius: 4px;margin-bottom: 24px;border: 0;overflow: hidden',
      visible: false,
      unit: {},
      videoUrl: '',
      mediaList: [],
      url:{
        unitMedia: '/teaching/teachingCourseUnit/unitMedia'
      },
      mediaContent: ''
    }
  },
  mounted() {
        // contextmenu 禁用右键菜单
    document.addEventListener('contextmenu',function(e){
        e.preventDefault();
    })
    //禁止复制  selectstart
    document.addEventListener('selectstart',function(e){
        e.preventDefault();
    })
  },
  methods: {
    handleCancel(e) {
      this.visible = false
      this.unit = {}
      this.videoUrl = ''
      this.mediaList = []
    },
    view(unit){
      this.visible = true
      this.unit = unit;
      this.getCourseMedia(unit.id);
    },
    getQiniuFile(text){
          if(!text){
            // this.$message.warning("未知的文件")
            return;
          }
          if(text.indexOf(",")>0){
            text = text.substring(0,text.indexOf(","))
          }
          return window._CONFIG['qn_base'] + text;
    },
    getCourseMedia(unitId){
      getAction(this.url.unitMedia, {id: unitId}).then(res=>{
        if(res.success){
          this.mediaList = res.result
          this.mediaList.forEach(item=>{
            if(item.mediaType == 1){
              this.videoUrl = item.mediaPath_url
            }
          })
        }else{
          this.$message.error(res.message)
        }
      }).catch(e=>{
        let data = e.response.data
        if (data.message.includes("Token失效")) {
          this.$message.error("未登录")
        }
      })
    },
    changeMedia(media){
      console.log(media);
      this.mediaContent = ''
      this.videoUrl = ''
      switch(media.mediaType){
        case 1:
          //切换视频
          this.videoUrl = media.mediaPath_url
          break;
        // case 2:
        //   //打开作业
        //     window.open('/scratch3/index.html?scene=twl&unitId='+this.unit.id + '&mediaId=' + media.id + '&workName=' + media.mediaName)
        //     break;
        // case 5:
        //     //打开作业
        //     window.open('/scratch3/index.html?scene=course&unitId='+this.unit.id + '&mediaId=' + media.id + '&workName=' + media.mediaName)
        //     break;
        // case 3:
        //     window.open(media.mediaPath_url)
        //       //打开PPT
        //     break;
        case 7: //富文本
          this.mediaContent = media.mediaContent
          break;
        default:
          this.handleViewCode(media)
      }
    },
    handleViewCode (media) {
      switch (media.codeType) {
        case 1:
          window.open('/scratch3/index.html?scene=twl&unitId='+this.unit.id + '&mediaId=' + media.id + '&workName=' + media.mediaName)
          break
        case 2:
          window.open('/scratch3/index.html?scene=twl&unitId='+this.unit.id + '&mediaId=' + media.id + '&workName=' + media.mediaName)
          break
        case 3:
          return window.open('/scratchjr/editor.html?mode=edit&filepath=' + media.mediaPath_url)
          break
        case 4:
          return window.open('/onlinecode/index.html?lang=turtle&unitId='+this.unit.id + '&mediaId=' + media.id + '&workName=' + media.mediaName)
          break
        case 5:
          return window.open('/onlinecode/index.html?lang=python&unitId='+this.unit.id + '&mediaId=' + media.id + '&workName=' + media.mediaName)
          break
        case 6:
          return window.open('/onlinecode/index.html?lang=c&unitId='+this.unit.id + '&mediaId=' + media.id + '&workName=' + media.mediaName)
          break
        case 7:
          return window.open('/onlinecode/index.html?lang=cpp&unitId='+this.unit.id + '&mediaId=' + media.id + '&workName=' + media.mediaName)
          break
        case 8:
          return window.open('/onlinecode/index.html?lang=java&unitId='+this.unit.id + '&mediaId=' + media.id + '&workName=' + media.mediaName)
          break
        default:
          window.open(this.getQiniuFile(media.mediaPath_url))
      }
  },
  },
}
</script>
<style lang="less" scoped>
.video-area{
  max-height: 700px;
  overflow: auto;
  video{
    width: 100%;
    height: 700px;
    // min-height: 500px;
  }
}
.unit-list{
  vertical-align:top;
  padding: 10px;
  margin: 0 20px;
  overflow-y: auto;
}
</style>
